module.exports = __webpack_public_path__ + "static/drone-08a11559cd572beefd64dfe732622f59.png";